// Fallback image for skis with no image_url. The Nordica Unleashed 108 shot
// from evo happens to look like a generic pair of skis (top-down view, plain
// graphics) so we reuse it as the placeholder until we either host our own or
// fill in the missing rows. If evo ever rotates this URL, swap in another.
export const SKI_PLACEHOLDER_IMAGE =
  'https://images.evo.com/imgp/700/266492/1178945/nordica-unleashed-108-skis-2026-.jpg';
